export { scenariosQuery, bucketsQuery, putScenarioMutation, assetLocationQuery } from "./queries";
